export default "__VITE_ASSET__CTx$fmE9__"